import { createFileRoute } from '@tanstack/react-router';

import { AdminPageContent } from '@/features/admin/components/AdminPageContent';
import {
  AdminPageHeader,
  BreadcrumbItemProps,
} from '@/features/admin/components/AdminPageHeader';
import { CreateCoursesRoot } from '@/features/manage-courses/components/create-course/CreateCoursesRoot';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

export const Route = createFileRoute(
  '/_app/app/admin-section/manage-courses/create'
)({
  component: RouteComponent,
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  ssr: false,
});

function RouteComponent() {
  const breadcrumbItems: BreadcrumbItemProps[] = [
    {
      label: 'Home',
      link: { to: '/app' },
    },
    {
      label: 'Manage Courses',
      link: { to: '/app/admin-section/manage-courses' },
    },
    {
      label: 'Create Course',
      link: {
        to: '/app/admin-section/manage-courses/create',
      },
    },
  ];

  return (
    <AdminPageContent className="overflow-hidden">
      <AdminPageHeader breadcrumbItems={breadcrumbItems} />
      <CreateCoursesRoot />
    </AdminPageContent>
  );
}
